import React from 'react';
import { Link } from 'react-router-dom';

/**
 * FloatingCTA Component
 * Fixed floating action buttons for fast contact.
 * Uses warm golden tones and direct access to contact page / phone.
 */
export default function FloatingCTA({
  phone = '66157902',
  phoneDisplay = '66 15 79 02',
  email = 'lone.hvid@hotmail.com'
}) {
  return (
    <aside
      aria-label="Hurtig kontakt"
      className="fixed bottom-6 right-5 sm:right-6 z-40 flex flex-col items-end gap-3 pointer-events-none"
    >
      <div className="flex flex-col items-center gap-3 pointer-events-auto">
        {/* Email CTA Button */}
        {email && (
          <a
            href={`mailto:${email}`}
            aria-label={`Send e-mail til ${email}`}
            title={`Send e-mail til ${email}`}
            className="group relative w-12 h-12 rounded-full bg-[#d9238c] hover:bg-[#be1878] text-white flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 ease-out hover:-translate-y-1 hover:scale-105 active:scale-95 border border-[#edd5e8]/40 focus:outline-none focus:ring-2 focus:ring-[#d9238c] focus:ring-offset-2"
          >
            <i className="fa-regular fa-envelope text-base text-white" aria-hidden="true"></i>
            <span className="pointer-events-none absolute right-14 whitespace-nowrap rounded-lg bg-[#381d6e] px-2.5 py-1 text-xs font-medium text-[#f7eefa] shadow-md opacity-0 group-hover:opacity-100 -translate-x-1 group-hover:translate-x-0 transition-all duration-200">
              Skriv mail ({email})
            </span>
          </a>
        )}

        {/* Kontakt Page Button */}
        <Link
          to="/kontakt"
          aria-label="Kontakt os på Ibjerget"
          title="Kontakt os på Ibjerget"
          className="group relative w-13 h-13 sm:w-14 sm:h-14 rounded-full bg-[#381d6e] hover:bg-[#4a2282] text-[#faf5f9] flex items-center justify-center shadow-xl hover:shadow-2xl transition-all duration-300 ease-out hover:-translate-y-1 hover:scale-105 active:scale-95 border-2 border-[#d9238c] focus:outline-none focus:ring-2 focus:ring-[#d9238c] focus:ring-offset-2"
        >
          <i className="fa-solid fa-phone text-lg sm:text-xl text-[#f7eefa]" aria-hidden="true"></i>
          <span className="pointer-events-none absolute right-16 whitespace-nowrap rounded-lg bg-[#381d6e] px-2.5 py-1 text-xs font-medium text-[#f7eefa] shadow-md opacity-0 group-hover:opacity-100 -translate-x-1 group-hover:translate-x-0 transition-all duration-200">
            Kontakt Lone & Niels
          </span>
        </Link>
      </div>
    </aside>
  );
}
